function normalizeEmail(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
}

function parseCanaryEmails(value) {
  return String(value || "")
    .split(",")
    .map(normalizeEmail)
    .filter(Boolean)
}

function mayUseEnhancedMyPage({
  email,
  runtimeProfile,
  canaryEmails,
  publicRelease,
}) {
  if (runtimeProfile === "staging-parity") {
    return true
  }

  if (publicRelease === true) {
    return true
  }

  const currentEmail = normalizeEmail(email)
  if (!currentEmail) {
    return false
  }

  return parseCanaryEmails(canaryEmails).includes(currentEmail)
}

module.exports = {
  mayUseEnhancedMyPage,
  normalizeEmail,
  parseCanaryEmails,
}
